declare const CONFIG: {
  VERSION: string;
  ENVIRONMENT: string;
  API_URL: string;
  APP_URL: string;
  TENANT: string;
};

export const { VERSION, ENVIRONMENT, API_URL, APP_URL, TENANT } = CONFIG;
